import React from "react";
import "./EmptyScreen.scss";

// give multiple icons based on the context of the empty screen, like no category, no menu items, no orders, etc.

const TickIcon = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="100" cy="100" r="90" fill="#f5f5f5" />
    <path
      d="M60 105 L90 135 L140 75"
      stroke="#4CAF50"
      strokeWidth="8"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const CrossIcon = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="100" cy="100" r="90" fill="#f5f5f5" />
    <path
      d="M70 70 L130 130 M130 70 L70 130"
      stroke="#b23f28"
      strokeWidth="8"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const getIcon = (iconType) => {
  switch (iconType) {
    case "tick":
      return <TickIcon />;
    case "cross":
      return <CrossIcon />;
    default:
      return <TickIcon />;
  }
}

function EmptyScreen({
  message = "All caught up",
  subText = "Nothing to show here right now",
  showIcon = true,
  iconType = "tick", // can be 'tick' or 'cross'
}) {
  return (
    <div className="empty-state">
      {showIcon && (
        <div className="empty-icon">
          {getIcon(iconType)}
        </div>
      )}

      <h3 className="empty-title">{message}</h3>
      <p className="empty-subtext">{subText}</p>
    </div>
  );
}

export default EmptyScreen;